import { useContext, useEffect, useState } from "react";
import { Layer } from "../../types/Layer";
import { LocalStorageKeys } from "../../types/LocalStorageKeys";
import { AuthContext } from "../../components/auth/AuthContext";
import { useMaintenanceModeContext } from "../MaintenanceMode/MaintenanceModeContext";
import { LayerContext } from "./LayerContext";
import { useLayerService } from "../../hooks";
import { Roles } from "../../constant/Roles";

interface LayerProviderProps {
  children: React.ReactNode;
}

const getStoredLayers = (): Layer[] => {
  const layers = localStorage.getItem(LocalStorageKeys.LAYERS);
  if (layers != null) {
    return JSON.parse(layers) as Layer[];
  }
  return [];
};

const LayerProvider = ({ children }: LayerProviderProps) => {
  const { user } = useContext(AuthContext)!;
  const { isMaintenance } = useMaintenanceModeContext();
  const [layers, setLayersState] = useState<Layer[]>(getStoredLayers);

  const isAdmin = user?.roles.includes(Roles.ADMINISTRATOR) ?? false;
  const layerService = useLayerService();

  const setLayers = (updatedLayers: Layer[]) => {
    setLayersState(updatedLayers);
    localStorage.setItem(
      LocalStorageKeys.LAYERS,
      JSON.stringify(updatedLayers),
    );
  };

  useEffect(() => {
    if (isMaintenance == null) {
      return;
    }

    if (isAdmin || !isMaintenance) {
      layerService.ListAvailable().then((fetchedLayers) => {
        setLayers(fetchedLayers);
      });
    } else {
      setLayersState([]);
    }
  }, [user, isMaintenance, isAdmin, layerService]);

  return (
    <LayerContext.Provider value={{ layers }}>{children}</LayerContext.Provider>
  );
};

export default LayerProvider;
